import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, BehaviorSubject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { User } from 'src/shared/Models/user.model';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url = 'https://backend-ub3c.onrender.com';
  user = new BehaviorSubject<any>(null)
  constructor(private http: HttpClient,
    private ngxSpinnerService: NgxSpinnerService,
    @Inject(Injector) private readonly injector: Injector) { }

  signIn(userName, email, password) {
    return this.http.post(this.url + '/signIn', { userName, email, password })
      .pipe(catchError(this.errorHandler.bind(this)), tap((resData) => {
        this.createUser(resData)
      }));
  }

  authGoogleUser(id_token) {
    return this.http.post<User>(this.url + '/googleAuthToken', { id_token })
      .pipe(catchError(this.errorHandler.bind(this)), tap((resData) => {
        this.createUser(resData)
      }));
  }

  logIn(email, password) {
    return this.http.post(this.url + '/logIn', { email, password })
      .pipe(catchError(this.errorHandler.bind(this)), tap((resData) => {
        this.createUser(resData)
      }));
  }

  autoLogIn() {
    const loginUser = JSON.parse(localStorage.getItem('loginDeatils'))
    if (!loginUser) {
      return
    }
    this.user.next(loginUser)
  }

  logOut() {
    return this.http.post(this.url + '/logOut', {})
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  //eventList functions

  eventList() {
    return this.http.get(this.url + '/eventList')
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  eventDetails(eventId) {
    return this.http.get<any>(this.url + '/eventDetails/' + eventId)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  registerUserForEvent(event_id, userDetails) {
    return this.http.put<any>(this.url + '/eventDetails/' + event_id, userDetails)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  registerUserForsquadEvent(event_id, userDetails) {
    return this.http.put<any>(this.url + '/squadeventDetails/' + event_id, userDetails)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  updateSquadDetails(event_id, userDetails) {
    return this.http.put<any>(this.url + '/updateSquadDetails/' + event_id, userDetails)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  getYoutubeLinks() {
    return this.http.get<any>(this.url + '/videoUrlList')
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  getSingleLeadersBoard() {
    return this.http.get<any>(this.url + '/singleLeadersBoard')
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  getAvatar() {
    return this.http.get<any>(this.url + '/avatar')
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  setAvatar(image) {
    return this.http.post<any>(this.url + '/avatar', image)
      .pipe(catchError(this.errorHandler.bind(this)))
  }
  getClanAvatar() {
    return this.http.get<any>(this.url + '/clanAvatar')
      .pipe(catchError(this.errorHandler.bind(this)))
  }
  setClanAvatar(image) {
    return this.http.post<any>(this.url + '/clanAvatar', image)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  getuserdetail() {
    return this.http.get<any>(this.url + '/userDetails')
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  createClan(clanDetails) {
    return this.http.post<any>(this.url + '/createClan', clanDetails)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  getClanList() {
    return this.http.get<any>(this.url + '/clansList')
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  createClanJoinRequesr(clan_id) {
    return this.http.post<any>(this.url + '/joinClan/' + clan_id, null)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  getClanDetails(clan_id) {
    return this.http.get<any>(this.url + '/clanDetails/' + clan_id)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  updateOnNewClanJoinRequest(clan_id, reqBody) {
    return this.http.post<any>(this.url + '/accecptRequest/' + clan_id, reqBody)
      .pipe(catchError(this.errorHandler.bind(this)))
  }

  getSearchDetails(keyWords) {
    return this.http.get<any>(this.url + '/searchUser/' + keyWords)
      .pipe(catchError(this.errorHandler.bind(this)))
  }
  private createUser(resData) {
    const user = new User(resData.user._id, resData.user.userName, resData.user.email, resData.token)
    this.user.next(user)
    localStorage.setItem('loginDeatils', JSON.stringify(user))
  }

  private get toastrService(): ToastrService {
    return this.injector.get(ToastrService);
  }
  errorHandler(error: HttpErrorResponse) {
    this.ngxSpinnerService.hide();
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      this.toastrService.error(error.error);
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

}
